/*
 *		Copyright (c) 2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

/* Filter to truncate a long string to a specified number of characters (plus 3 dots '...') */

'use strict';

angular.module('accessWebClient')
    .filter('truncateString', [function () {
        return function (string, numSymbols) {
            if (!string || isNaN(numSymbols)) return;
            if (string.length <= numSymbols) return string;
            
            var
                number = numSymbols / 2,
                firstHalf = string.slice(0, number),
                secondHalf = string.slice(-number);

            return firstHalf + '...' + secondHalf;
        }
    }]);